import { Form, Input, InputNumber, Select, Spin } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import { AgencyOperationBean, OperationBean } from 'common/api/api.ts'
import { agencyBalanceApi } from 'common/api/entitiesApi.tsx'
import { AnchorsForm } from 'common/components/AnchorsForm.tsx'
import { ButtonsPanel } from 'common/components/ButtonsPanel.tsx'
import { FormCard } from 'common/components/FormCard.tsx'
import { AgencySelector } from 'common/components/reloadable/AgencySelector.tsx'
import { useAppContext } from 'common/context/AppContext.tsx'
import { apiCall } from 'common/util/Util.tsx'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

type FormShape = {
  agencyId?: number
  operationType: OperationBean.OperationTypeEnum
  amount: number
  note?: string
}

const AgencyTransactionForm: React.FC = () => {
  const navigateTo = useNavigate()
  const appContext = useAppContext()
  const { id } = useParams<{ id: string }>()

  const [form] = Form.useForm<FormShape>()
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const defaults: Partial<FormShape> = {
      agencyId: id ? Number(id) : undefined,
      operationType: OperationBean.OperationTypeEnum.ADD,
    }
    form.setFieldsValue(defaults as any)
  }, [id])

  const handleSubmit = () => {
    setLoading(true)
    form
      .validateFields()
      .then((values) =>
        apiCall(setLoading, appContext, () => agencyBalanceApi.agencyOperate(values as AgencyOperationBean), onCancel),
      )
  }

  function onCancel() {
    navigateTo(id ? '/agency' : '/agency-transactions')
  }

  return (
    <Spin spinning={loading}>
      <AnchorsForm form={form} onFinish={handleSubmit}>
        <FormCard id="general" title="General">
          <FormItem name="agencyId" rules={[{ required: true, message: 'Agency is required' }]} label="Agency">
            <AgencySelector placeholder="Select agency" />
          </FormItem>

          <FormItem name="operationType" rules={[{ required: true, message: 'Choose operation' }]} label="Operation">
            <Select
              options={[
                { label: 'Add money', value: OperationBean.OperationTypeEnum.ADD },
                { label: 'Subtract money', value: OperationBean.OperationTypeEnum.SUBTRACT },
              ]}
              placeholder="Select Operation"
            />
          </FormItem>

          <FormItem
            name="amount"
            rules={[
              { required: true, message: 'Please input amount of money', type: 'number' },
              { message: 'Amount of money should be positive', type: 'number', min: 0.01 },
            ]}
            label="Amount"
          >
            <InputNumber min={0.01} style={{ width: 200 }} suffix="$" />
          </FormItem>

          <FormItem
            name="note"
            rules={[
              {
                required: false,
                max: 1000,
                type: 'string',
                message: 'Note should be less than 1000 symbols',
              },
            ]}
            label="Note for Agency"
          >
            <Input placeholder="Optional note" />
          </FormItem>
        </FormCard>

        <ButtonsPanel onCancel={onCancel} />
      </AnchorsForm>
    </Spin>
  )
}

export default AgencyTransactionForm
